/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} ScheduleInputs */

const th_schedule = /** @type {(inputs: ScheduleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ตารางแข่งขัน`)
};

const en_schedule = /** @type {(inputs: ScheduleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schedule`)
};

const ja_schedule = /** @type {(inputs: ScheduleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`日程`)
};

const zh_schedule = /** @type {(inputs: ScheduleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`赛程`)
};

const es_schedule = /** @type {(inputs: ScheduleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calendario`)
};

const pt_schedule = /** @type {(inputs: ScheduleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calendário`)
};

const id_schedule = /** @type {(inputs: ScheduleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jadwal`)
};

const fr_schedule = /** @type {(inputs: ScheduleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calendrier`)
};

const tl_schedule = /** @type {(inputs: ScheduleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iskedyul`)
};

const vi_schedule = /** @type {(inputs: ScheduleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lịch thi đấu`)
};

const ko_schedule = /** @type {(inputs: ScheduleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`일정`)
};

const de_schedule = /** @type {(inputs: ScheduleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spielplan`)
};

const ru_schedule = /** @type {(inputs: ScheduleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Расписание`)
};

const tr_schedule = /** @type {(inputs: ScheduleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fikstür`)
};

const it_schedule = /** @type {(inputs: ScheduleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calendario`)
};

const pl_schedule = /** @type {(inputs: ScheduleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terminarz`)
};

const uk_schedule = /** @type {(inputs: ScheduleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Розклад`)
};

const hi_schedule = /** @type {(inputs: ScheduleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कार्यक्रम`)
};

const ar_schedule = /** @type {(inputs: ScheduleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الجدول`)
};

const ms_schedule = /** @type {(inputs: ScheduleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jadual`)
};

const bn_schedule = /** @type {(inputs: ScheduleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`সূচি`)
};

const zh_tw2_schedule = /** @type {(inputs: ScheduleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`賽程`)
};

const zh_hk2_schedule = /** @type {(inputs: ScheduleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`賽程`)
};

const ur_schedule = /** @type {(inputs: ScheduleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`شیڈول`)
};

const fa_schedule = /** @type {(inputs: ScheduleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`برنامه`)
};

const sw_schedule = /** @type {(inputs: ScheduleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ratiba`)
};

const nl_schedule = /** @type {(inputs: ScheduleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schema`)
};

/**
* | output |
* | --- |
* | "Schedule" |
*
* @param {ScheduleInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const schedule = /** @type {((inputs?: ScheduleInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<ScheduleInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_schedule(inputs)
	if (locale === "ja") return ja_schedule(inputs)
	if (locale === "zh") return zh_schedule(inputs)
	if (locale === "es") return es_schedule(inputs)
	if (locale === "pt") return pt_schedule(inputs)
	if (locale === "id") return id_schedule(inputs)
	if (locale === "fr") return fr_schedule(inputs)
	if (locale === "tl") return tl_schedule(inputs)
	if (locale === "vi") return vi_schedule(inputs)
	if (locale === "ko") return ko_schedule(inputs)
	if (locale === "de") return de_schedule(inputs)
	if (locale === "ru") return ru_schedule(inputs)
	if (locale === "tr") return tr_schedule(inputs)
	if (locale === "it") return it_schedule(inputs)
	if (locale === "pl") return pl_schedule(inputs)
	if (locale === "uk") return uk_schedule(inputs)
	if (locale === "hi") return hi_schedule(inputs)
	if (locale === "ar") return ar_schedule(inputs)
	if (locale === "ms") return ms_schedule(inputs)
	if (locale === "bn") return bn_schedule(inputs)
	if (locale === "zh-TW") return zh_tw2_schedule(inputs)
	if (locale === "zh-HK") return zh_hk2_schedule(inputs)
	if (locale === "ur") return ur_schedule(inputs)
	if (locale === "fa") return fa_schedule(inputs)
	if (locale === "sw") return sw_schedule(inputs)
	if (locale === "nl") return nl_schedule(inputs)
	return en_schedule(inputs)
});